import { useCallback } from 'react';

import { trpcClient } from '@/services/trpc';

import { useUser } from './useUser';

export const useOrganizationChange = () => {
  const { setJwt, setCurrentOrganizationId } = useUser();

  return useCallback(
    async (value: string | undefined) => {
      if (!value) {
        return;
      }

      // Switch to new organization
      const jwt = await trpcClient.auth.switchOrganization.mutate({
        id: value,
      });

      // Update access token
      setJwt(jwt.access);
      setCurrentOrganizationId(value);

      // Reload page
      window.location.pathname = '/';
    },
    [setJwt, setCurrentOrganizationId],
  );
};
